import React, { useEffect } from 'react'
import { useGlobalState } from 'src/provider/GlobalStateProvider'

interface Props {
  name: string
  type: string
  slug: string
}

const SetServiceContext: React.FC<Props> = ({ name, type, slug }) => {
  const { setActiveService } = useGlobalState()

  useEffect(() => {
    setActiveService({ name, slug, type })
  }, [name, slug, type])

  return null
}

export default SetServiceContext
